export class TableLinkedSymbolComponent {
    symbol!: string;

    get searchUrl() {
        return `/search?q=${encodeURIComponent('#') + this.symbol}#post`;
    }
}

angular.module('tradersyard').component('tySymbolLink', {
    // language=HTML
    template: `
        <a ng-href="{{$ctrl.searchUrl}}">#{{$ctrl.symbol}}</a>
    `,
    controller: TableLinkedSymbolComponent,
    bindings: {
        symbol: '<',
    },
});
